export default __webpack_public_path__ + "static/media/rif_black.b9a8ebea.svg";